import { LegacyRef, MouseEventHandler } from 'react';
import {
  ColumnFiltersState,
  PaginationState,
  SortingState,
  Row,
  RowData,
  Table,
} from '@tanstack/react-table';

export type ColumnRefFactory = (
  index: number,
  headerId: string,
) => LegacyRef<HTMLTableHeaderCellElement>;

export type RowClickCallback<TData extends RowData> = (
  rowData: TData,
  row: Row<TData>,
) => MouseEventHandler<HTMLTableRowElement>;

export type RowNavigationProp<TData extends RowData> =
  | boolean
  | ((rowData: TData) => string | undefined);

export type UrlKey = string | undefined;

// eslint-disable-next-line @typescript-eslint/ban-types
export type Statable = Exclude<unknown, Function>;

export type UpdaterFn<S> = (currentState: S) => S;
export type Updater<S> = S | UpdaterFn<S>;

export function isUpdaterFn<S>(u: Updater<S>): u is UpdaterFn<S> {
  return typeof u === 'function';
}

export type Setter<S> = (value: Updater<S>) => void;
export type UseStateReturn<S> = [S, Setter<S>];
export type UseStateFunction<S> = (initialState: S) => UseStateReturn<S>;

export type TableStateManager = {
  usePaginationState: UseStateFunction<PaginationState>;
  useSortingState: UseStateFunction<SortingState>;
  useColumnFiltersState: UseStateFunction<ColumnFiltersState>;
};
